var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"focus:outline-none relative overflow-hidden",class:{
        ['bg-'+_vm.color]: !_vm.flat && !_vm.disabled && !_vm.outlined,
        'bg-gray-300': _vm.disabled && !_vm.icon,
        'text-back': !_vm.dark,
        'text-white': _vm.dark,
        'rounded-full': !_vm.tile,
        border: _vm.outlined && !_vm.flat && !_vm.fab && !_vm.icon,
        ['border-'+_vm.color]: _vm.outlined && _vm.color !== 'transparent',
        'border-black': _vm.outlined && _vm.color === 'transparent',
        'p-1': !_vm.noPadding && !_vm.fab,
        'shadow-xl': _vm.fab,
        'w-full': _vm.block
    },style:({
        width: !_vm.fab ? parseInt(_vm.width) > 50 ? _vm.parse(_vm.width) : '' : _vm.parse(_vm.size),
        'min-height': !_vm.fab ? _vm.parse(_vm.height) : _vm.parse(_vm.size) ,
        'cursor': _vm.disabled ? 'default' : 'pointer'
    }),on:{"mousedown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"]))return null;if('button' in $event && $event.button !== 0)return null;return _vm.clicked($event)}}},[_c('row',{staticClass:"uppercase flex w-full items-center button-content z-10",attrs:{"justify":(_vm.fab || _vm.icon) ? 'center' : 'space-between'}},[(!_vm.loading)?_vm._t("default",function(){return [_vm._v("Button")]}):_vm._e(),(_vm.loading)?_c('div',{staticClass:"w-full h-full flex items-center justify-center"},[_c('loader',{staticClass:"my-3",attrs:{"show-text":false}})],1):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }